import { useEffect, useRef } from 'react';
import { AlertStatus } from './AlertStatus';

interface IAlertDetails {
  visible?: boolean;
  message?: string;
  status?: number;
  className?: string;
  scrollTo?: string;
}

export const AlertMessage = ({ visible, message, status, className, scrollTo }: IAlertDetails) => {
  const alertRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!scrollTo || !alertRef.current || !visible) {
      return;
    }
    alertRef.current.scrollIntoView({ behavior: 'smooth' });
  }, [scrollTo, visible, message, status]);

  if (!visible) return <></>;

  let classNames;
  switch (status) {
    case AlertStatus.SUCCESS:
      classNames = 'alert alert-success';
      break;
    case AlertStatus.ERROR:
      classNames = 'alert alert-danger';
      break;
    case AlertStatus.WARNING:
      classNames = 'alert alert-warning';
      break;
    default:
      classNames = 'alert alert-primary';
  }

  if (className && className.trim().length > 0) {
    classNames += ' ' + className;
  }

  return (
    <div className={classNames} ref={alertRef}>
      {message}
    </div>
  );
};
